import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Percent sign inside a circle — the Rebates nav group icon (Figma node 27662:28642).
 * Stroke uses `currentColor` so it follows the nav item's text color like the sibling icons.
 */
export const Percent = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" strokeWidth="1.8" />
    <path
      d="M15.5 8.5L8.5 15.5"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <circle cx="9.5" cy="9.5" r="1.25" fill="currentColor" />
    <circle cx="14.5" cy="14.5" r="1.25" fill="currentColor" />
  </SvgIcon>
);
